<template>
  <div class="day-cal__event-container"
       @pointerenter="onMouseEnterDay"
       @pointerleave="onMouseLeaveDay">
    <div class="day-cal__event-container__events" v-if="isDraggingEvent"
         :class="[{'day-cal__event-container__events--active--resizing': isResizingEvent}, {'day-cal__event-container__events--active': dragLesson}]">
      <div class="day-cal__event day-cal__event--dragged" v-if="dragLesson && isActiveDay"
           data-cols="1"
           :class="{'day-cal__event--is-small': dragEventHeight < 20}"
           :style="{'borderColor': dragLesson.obj.color, 'height': dragEventHeight + 'px', 'top': (dragEventY - 1) + 'px', 'left': 0, 'width': '100%', 'zIndex': 100}">
        <div class="day-cal__event__content">
          <div class="day-cal__event__content__header">
            <div class="d-cal__event-title">{{ dragLesson.obj.title }}</div>
            <div class="d-cal__event-time">
              <span class="d-cal__event-time__start">{{ dragEventStartTime }} - {{ dragEventEndTime }}</span>
              <span v-if="dragLesson.obj.has_notes" class="d-cal__event-meta icon-file-text2"></span>
              <span v-if="dragLesson.obj.has_substitute" class="d-cal__event-meta icon-users3"></span>
            </div>
          </div>
          <div class="day-cal__event__calendar" v-show="dragLesson.obj.teacher"><span class="icon-user"></span>
            {{ dragLesson.obj.teacher }}
          </div>
          <div class="day-cal__event__calendar" v-show="dragLesson.obj.group"><span class="icon-users"></span>
            {{ dragLesson.obj.group }}
          </div>
          <div class="day-cal__event__calendar" v-show="dragLesson.obj.room"><span class="icon-location"></span>
            {{ dragLesson.obj.room }}
          </div>
        </div>
        <div class="day-cal__event__bg" :style="{backgroundColor: dragLesson.obj.color}" style="opacity: 1"></div>
        <div class="day-cal__event__sider" :style="{backgroundColor: dragLesson.obj.color}"></div>
      </div>
    </div>
    <div class="day-cal__event-container__events" :class="{'day-cal__event-container__events--highlighted': isCopyCalendarModalOpen}">
      <div v-for="event in correctEvents"
           :key="event.obj.event_key"
           @click="onNativeEventClick(event, $event)"
           @pointerdown.prevent="onMouseDown(event, $event)"
           class="day-cal__event"
           :data-cols="event.cols ? event.cols : 1"
           :data-subject-type="event.obj.event_type"
           :class="[{'day-cal__event--is-away': event.obj.away}, {'day-cal__event--is-canceled': event.obj.canceled}, {'day-cal__event--has-warning': event.obj.collision}, {'day-cal__event--is-other-calendar': event.obj.v_other_calendar}, {'day-cal__event--is-locked': isLocked}, {'day-cal__event--is-small': event.height < 20}, {'day-cal__event--other-school': event.obj.v_other_school}, {'day-cal__event--editable': event.obj.v_is_editable}, {'day-cal__event--hide': dragLesson && dragLesson.obj.event_id === event.obj.event_id && isDraggingEvent}, {'fc-bgevent__presence': event.obj.event_type === 'presence'}, {'day-cal__event--clickable': isEventsClickable}, {'day-cal__event--availability': event.obj.rendering}]"
           :style="{'borderColor': event.obj.color, 'height': event.height + 'px', 'top': (event.top - 1) + 'px', 'left': event.left + '%', 'width': event.width + '%'}">
        <div class="day-cal__event__content" v-if="!event.obj.v_other_school && event.obj.event_type !== 'presence'"
             :class="{'day-cal__event__content--loading': event.obj.v_is_loading}"
             :style="{'borderColor': event.obj.color}">
          <div class="day-cal__event__content__header">
            <div class="d-cal__event-title">
              <div class="d-cal__event__other-calendar js-no-click" v-if="event.obj.v_other_calendar"
                   @click.stop.prevent="goToCalendar(event.obj.calendar_id, $event)" :content="customTooltip(event.obj)"
                   v-tippy="{
                arrow: true,
                animateFill: false,
                animation: 'shift-away',
                zIndex: '999999992',
                boundary: 'window'
              }">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     :stroke="event.obj.color" class="js-no-click tw-icon w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"/>
                </svg>
              </div>
              <span class="icon-home2 icon-home2-away icon-home2-away--schedules" v-if="event.obj.away"></span>
              {{ event.obj.title }}
            </div>
            <div class="d-cal__event-time">
              <span class="d-cal__event-time__start">{{ event.obj.event_starttime }} - {{
                  event.obj.event_endtime
                }}</span>
              <span v-if="event.obj.has_notes" class="d-cal__event-meta icon-file-text2"></span>
              <span v-if="event.obj.has_substitute" class="d-cal__event-meta icon-users3"></span>
              <div class="d-cal__event-meta d-cal__event-meta__fixed d-cal__event-meta--warning"
                   :class="{'d-cal__event-meta__fixed--canceled': event.obj.canceled}"
                   v-if="event.obj.collision || event.obj.away || event.obj.canceled">
                <span class="icon-notification22" v-if="event.obj.canceled"></span>
                <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke-width="1.5" stroke="currentColor" class="tw-icon tw-icon--warning">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"></path>
                </svg>
                {{ getEventWarningLabel(event.obj) }}
              </div>
            </div>
          </div>
          <div class="day-cal__event__calendar" v-if="isCalendarTypeRoom && event.obj.group"><span
            class="icon-users"></span>
            {{ event.obj.group }}
          </div>
          <div class="day-cal__event__calendar" v-show="event.obj.teacher"><span class="icon-user"></span>
            {{ event.obj.teacher }}
          </div>
          <div class="day-cal__event__calendar" v-if="!isCalendarTypeRoom && event.obj.group"><span
            class="icon-users"></span>
            {{ event.obj.group }}
          </div>
          <div class="day-cal__event__calendar" v-show="event.obj.room"><span class="icon-location"></span>
            {{ event.obj.room }}
          </div>
        </div>
        <div class="day-cal__event__content" v-if="event.obj.v_other_school">
          <div class="day-cal__event__content__header">
            <div class="d-cal__event-title">{{ i18n['other_school'] }}</div>
            <div class="d-cal__event-time">
              <span class="d-cal__event-time__start">{{ event.obj.event_starttime }} - {{
                  event.obj.event_endtime
                }}</span>
            </div>
          </div>
        </div>
        <div class="d-event__side__resizer"
             v-if="event.obj.v_is_editable && !isLocked && !event.obj.v_is_loading"></div>
        <div class="d-event__resizer" v-if="event.obj.v_is_editable && !isLocked"></div>
        <div class="day-cal__event__bg" v-if="event.obj.event_type !== 'presence'"
             :style="{backgroundColor: event.obj.color}"></div>
        <div class="day-cal__event__sider" v-if="!event.obj.v_other_calendar && event.obj.event_type !== 'presence'"
             :style="{backgroundColor: event.obj.color}"></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import eventbus from '../../eventbus'

const I18N = {
  da: {
    other_school: 'Anden skole',
    this_event_can_only_be_edited_in: 'Denne brik kan kun redigeres i',
    where_it_initially_was_scheduled: 'hvor den er skemalagt',
    the_calendar: 'den kalender',
    go_to: 'Gå til',
    out_of_school: 'Ude af huset',
    canceled: 'Aflyst'
  },
  en: {
    other_school: 'Other school',
    this_event_can_only_be_edited_in: 'This event can only be edited in',
    where_it_initially_was_scheduled: 'where it is scheduled',
    the_calendar: 'the calendar',
    go_to: 'Go to',
    out_of_school: 'Out of school',
    canceled: 'Canceled'
  },
  nb: {
    other_school: 'Annen skole',
    this_event_can_only_be_edited_in: 'Denne timen kan kun redigeres i',
    the_calendar: 'den kalenderen',
    where_it_initially_was_scheduled: 'hvor den opprinnelig er planlagt',
    go_to: 'Gå til',
    out_of_school: 'Utenfor skolen',
    canceled: 'Avlyst'
  }
}

export default {
  props: {
    calendar: {
      type: Object,
      default: null
    },
    calendarId: {
      default: 7
    },
    events: {
      type: Array,
      default: () => []
    },
    date: {},
    slotHeight: {
      default: 40
    },
    calStartTime: {
      default: '08:00:00'
    },
    calEndTime: {
      default: '17:00:00'
    },
    isEventsClickable: {
      type: Boolean,
      default: false
    },
    dragLesson: {
      type: Object,
      default: () => null
    },
    dragEventY: {
      type: Number,
      default: 0
    },
    dragEventHeight: {
      type: Number,
      default: 0
    },
    dragActiveDate: {
      type: Object,
      default: () => null
    },
    isResizingEvent: {
      type: Boolean,
      default: false
    },
    isDraggingEvent: {
      type: Boolean,
      default: false
    },
    isDraggingExternalEvent: {
      type: Boolean,
      default: false
    },
    theExternalEvent: {
      type: Object,
      default: null
    },
    dragEventStart: {},
    dragEventEnd: {},
    isLocked: {
      type: Boolean,
      default: false
    },
    dragActiveDates: {
      type: Array,
      default: () => []
    },
    isSideResizingEvent: {
      type: Boolean,
      default: false
    },
    isCopyCalendarModalOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      correctEvents: [],
      firstEvent: true,
      isWindowResizing: false,
      dragLessonId: null,
      startY: 0,
      startX: 0,
      delta: 2,
      distanceMovedY: null,
      distanceMovedX: null,
      raf: null
    }
  },
  computed: {
    isCalendarTypeRoom () {
      return this.calendar && this.calendar.type ? this.calendar.type === 'room' : false
    },
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale]
    },
    dragEventStartTime () {
      return moment(this.dragEventStart).format('LT')
    },
    dragEventEndTime () {
      return moment(this.dragEventEnd).format('LT')
    },
    dayLessons () {
      return this.events.filter(lesson => moment(lesson.start).format('YYYY-MM-DD') === moment(this.date).format('YYYY-MM-DD'))
    },
    isActiveDay () {
      if (!this.isSideResizingEvent) {
        if (!this.dragActiveDate) {
          return false
        }
        return moment(this.date).isSame(this.dragActiveDate)
      } else {
        if (this.dragActiveDates.length < 1) {
          return false
        }
        const date = moment(this.date).format('YYYY-MM-DD')
        return this.dragActiveDates.includes(date)
      }
    }
  },
  watch: {
    dayLessons () {
      this.updateEventsPositions()
    },
    slotHeight () {
      this.updateEventsPositions()
    },
    calStartTime () {
      this.updateEventsPositions()
    },
    calEndTime () {
      this.updateEventsPositions()
    }
  },
  methods: {
    getEventWarningLabel (eventObj) {
      if (eventObj.canceled) {
        return this.i18n.canceled
      }
      if (eventObj.away) {
        return this.i18n.out_of_school
      }
    },
    onNativeEventClick (event, evt) {
      if (event && event.obj && event.obj.event_type === 'presence') {
      } else {
        evt.stopPropagation()
      }
    },
    onMouseEnterDay (evt) {
      if (!this.dragLesson && !this.theExternalEvent) {
        return
      }
      if (this.dragLesson || !this.isResizingEvent || this.theExternalEvent) {
        this.$emit('setDragActiveDate', this.date)
        if (this.isDraggingExternalEvent) {
          // Find top of the calendar and calc numbers of px from the top the mouse enters
          this.startY = evt.pageY
          this.startX = evt.pageX
          const elTop = document.querySelector('.day-cal__event-container').getBoundingClientRect().top - 1 // -1 for border
          const mouseEnterDayPxFromTop = evt.clientY
          const PxFromTopOfCal = mouseEnterDayPxFromTop - elTop
          // Bind to the closest 5 minutes in px
          const fiveMinutesInPx = this.slotHeight / 6 // this.slotHeight = 30 min / 6 = 5 min
          const closestFiveMinutesInPx = Math.floor(PxFromTopOfCal / fiveMinutesInPx) * fiveMinutesInPx
          // Calc starttime and endtime based on PxFromTopOfCal
          let numberOfMinutesToMultiply = Math.floor(PxFromTopOfCal / fiveMinutesInPx)
          let minutes = 5 * Math.abs(numberOfMinutesToMultiply)
          const startTime = moment(this.calStartTime).add(minutes, 'minutes')
          const endTime = moment(startTime).add(this.theExternalEvent.default_duration, 'minutes')
          // create the dragLesson
          let eventCals = this.theExternalEvent.cals
          const isNotThisCalendar = this.theExternalEvent.calendar_id !== this.calendarId
          const isNotInCalsArrAlready = eventCals.findIndex(cal => cal.id === this.theExternalEvent.calendar_id) < 0
          if (isNotThisCalendar && isNotInCalsArrAlready) {
            const otherCal = {id: this.theExternalEvent.calendar_id}
            eventCals.push(otherCal)
          }
          const event = {
            school_id: this.theExternalEvent.school_id,
            subject_id: this.theExternalEvent.id,
            calendarIds: [],
            title: this.theExternalEvent.title,
            end: endTime,
            start: startTime,
            color: this.theExternalEvent.color,
            event_id: null,
            calendars: eventCals,
            event_type: this.theExternalEvent.subjectType,
            calendar_id: this.calendarId,
            description: '',
            learning_goal: '',
            teacher_notes: '',
            notes_for_students: '',
            has_notes: false,
            group: '',
            teacher: '',
            room: '',
            substitutes: null,
            eventDuration: this.theExternalEvent.default_duration,
            v_other_school: false,
            v_is_editable: true
          }
          const lesson = {
            top: closestFiveMinutesInPx,
            height: this.eventHeight(event),
            bottom: 0,
            left: 0,
            width: 100,
            obj: event
          }
          this.onMouseDown(lesson, evt)
          this.$emit('setIsDraggingExternalEvent', false)
        }
      }
    },
    onMouseLeaveDay (evt) {
      if (!this.dragLesson || this.isResizingEvent || this.isSideResizingEvent) {
        return
      }
      this.$emit('setDragActiveDate', null)
    },
    getIsMouseDownAllowed (lesson) {
      return this.isEventsClickable && !lesson.obj.v_other_school && lesson.obj.event_type !== 'presence' && !lesson.obj.v_is_loading
    },
    onMouseDown (lesson, evt) {
      // return if right clicks on mouse && if calendar not editable
      if (!this.getIsMouseDownAllowed(lesson) || evt.button === 2 || evt.button === 1 || evt.target.classList.contains('js-no-click')) {
        return
      }
      evt.target.releasePointerCapture(evt.pointerId)
      if (evt.target.classList.contains('d-event__resizer')) {
        this.$emit('setIsResizingEvent', true)
      }
      if (evt.target.classList.contains('d-event__side__resizer')) {
        this.$emit('setIsSideResizingEvent', true)
      }
      this.startY = evt.pageY
      this.startX = evt.pageX
      this.$emit('setDragEventY', lesson.top)
      this.$emit('setDragEventHeight', lesson.height)
      this.$emit('setDragLesson', lesson)
      this.$emit('setDragEventStart', lesson.obj.start)
      this.$emit('setDragEventEnd', lesson.obj.end)
      this.$emit('setDragActiveDate', this.date)
      if (lesson.obj.v_is_editable && !this.isLocked) {
        document.addEventListener('pointermove', this.onMouseMove, {passive: true})
      }
      document.addEventListener('pointerup', this.onMouseUp, {passive: true})
      document.addEventListener('pointercancel', this.onMouseUp, {passive: true})
    },
    onMouseUp (evt) {
      if (this.dragActiveDate) {
        this.getIsDragOrClick(evt)
      }
      this.$emit('onMouseUp')
      this.cleanUp()
      document.removeEventListener('pointermove', this.onMouseMove)
      document.removeEventListener('pointerup', this.onMouseUp)
      document.addEventListener('pointercancel', this.onMouseUp)
      this.distanceMovedY = null
      this.distanceMovedX = null
      if (this.raf) {
        window.cancelAnimationFrame(this.raf)
        this.raf = null
      }
    },
    getIsDragOrClick (evt) {
      if ((!this.dragLesson.obj.v_is_editable && !this.dragLesson.obj.v_other_calendar) || (this.isLocked && !this.dragLesson.obj.v_other_calendar)) {
        this.onEventClick(evt)
        return
      }
      if (!this.isDraggingEvent) {
        // It's a click
        this.onEventClick(evt)
      } else {
        // It's a drag
        if (this.dragLesson.obj.v_other_calendar) {
          const parentCalendarName = this.dragLesson.obj.v_other_calendar && this.dragLesson.obj.v_other_calendar.name ? this.dragLesson.obj.v_other_calendar.name : this.i18n['the_calendar']
          const txt = this.i18n['this_event_can_only_be_edited_in'] + ' ' + parentCalendarName + ', ' + this.i18n['where_it_initially_was_scheduled']
          eventbus.toast = {text: txt, 'success': false}
          return
        }
        this.updateEventTimes()
      }
    },
    updateEventTimes () {
      if (this.isSideResizingEvent) {
        if (this.dragActiveDates.length < 1) {
          return
        }
        const eventsToCreate = []
        this.dragActiveDates.forEach((dragDate, key) => {
          // Create a new copy of this.dragLesson.obj for each iteration
          let newEvent = Object.assign({}, this.dragLesson.obj)
          const year = moment(dragDate).year()
          const month = moment(dragDate).month()
          const day = moment(dragDate).date()
          const newStartTime = moment(newEvent.start).set({
            year: year,
            month: month,
            date: day,
            millisecond: 0
          })
          const newEndTime = moment(newEvent.end).set({
            year: year,
            month: month,
            date: day,
            millisecond: 0
          })
          newEvent.event_id = 'new_temp_id_' + key
          newEvent.start = newStartTime
          newEvent.end = newEndTime
          newEvent.v_is_loading = true
          eventsToCreate.push(newEvent)
        })
        this.$store.dispatch('createCalendarEvents', eventsToCreate)
        return
      }
      let year = moment(this.dragActiveDate).year()
      let month = moment(this.dragActiveDate).month()
      let date = moment(this.dragActiveDate).date()
      const newStartTime = moment(this.dragEventStart).set({
        'year': year,
        'month': month,
        'date': date,
        'millisecond': 0
      })
      const newEndTime = moment(this.dragEventEnd).set({'year': year, 'month': month, 'date': date, 'millisecond': 0})
      if (this.dragLesson.obj.event_id) {
        let updatedArr = {
          school_id: this.dragLesson.obj.school_id,
          updates: [{
            event_id: this.dragLesson.obj.event_id,
            calendar_id: this.dragLesson.obj.calendar_id,
            start_time: newStartTime,
            end_time: newEndTime
          }]
        }
        this.$store.dispatch('updateCalendarEvent', updatedArr)
      } else {
        this.dragLesson.obj.event_id = 'new_temp_id'
        this.dragLesson.obj.start = newStartTime
        this.dragLesson.obj.end = newEndTime
        this.dragLesson.obj.calendar_id = this.calendarId
        this.dragLesson.obj.v_is_loading = true
        this.$store.dispatch('createCalendarEvent', this.dragLesson.obj)
      }
    },
    onMouseMove (evt) {
      if (!this.raf) {
        this.distanceMovedY = evt.pageY - this.startY
        this.distanceMovedX = evt.pageX - this.startX
        this.raf = window.requestAnimationFrame(this.moveEvent)
        const cursorPlacement = {
          x: evt.pageX,
          y: evt.pageY
        }
        this.$emit('setTheDeleteSubjectCursorPlacement', cursorPlacement)
      }
    },
    moveEvent () {
      const distanceMovedY = this.distanceMovedY
      const distanceMovedX = this.distanceMovedX
      if (Math.abs(distanceMovedY) > this.delta || Math.abs(distanceMovedX) > this.delta) {
        if (!this.isDraggingEvent) {
          this.$emit('setIsDraggingEvent', true)
        }
      }
      const fiveMinutesInPx = this.slotHeight / 6 // this.slotHeight = 30 min / 6 = 5 min
      const numberOfMinutesToMultiply = Math.floor(distanceMovedY / fiveMinutesInPx)
      const minutes = 5 * Math.abs(numberOfMinutesToMultiply)
      let dragEventStart, dragEventEnd
      if (!this.isResizingEvent && !this.isSideResizingEvent) {
        if (numberOfMinutesToMultiply > 0) {
          dragEventStart = moment(this.dragLesson.obj.start).add(minutes, 'minutes')
          dragEventEnd = moment(this.dragLesson.obj.end).add(minutes, 'minutes')
        } else {
          dragEventStart = moment(this.dragLesson.obj.start).subtract(minutes, 'minutes')
          dragEventEnd = moment(this.dragLesson.obj.end).subtract(minutes, 'minutes')
        }
        this.$emit('setDragEventStart', dragEventStart)
        this.$emit('setDragEventEnd', dragEventEnd)
        this.$emit('setDragEventY', this.dragLesson.top + (fiveMinutesInPx * numberOfMinutesToMultiply))
      } else if (this.isResizingEvent) {
        if (numberOfMinutesToMultiply > 0) {
          dragEventEnd = moment(this.dragLesson.obj.end).add(minutes, 'minutes')
        } else {
          dragEventEnd = moment(this.dragLesson.obj.end).subtract(minutes, 'minutes')
          if (moment(dragEventEnd).isSameOrBefore(this.dragLesson.obj.start)) {
            dragEventEnd = moment(this.dragLesson.obj.start).add(5, 'minutes')
          }
        }
        const dragEventHeight = (this.dragLesson.height + (fiveMinutesInPx * numberOfMinutesToMultiply)) > 0 ? (this.dragLesson.height + (fiveMinutesInPx * numberOfMinutesToMultiply)) : fiveMinutesInPx
        this.$emit('setDragEventEnd', dragEventEnd)
        this.$emit('setDragEventHeight', dragEventHeight)
      }
      // once the paint job is done we 'release' animation frame variable to allow next paint job:
      this.raf = null
    },
    cleanUp () {
      this.$emit('setDragActiveDate', null)
      this.$emit('setDragLesson', null)
      this.$emit('setIsResizingEvent', false)
      this.$emit('setIsSideResizingEvent', false)
      this.$emit('setIsDraggingEvent', false)
    },
    updateEventsPositions () {
      this.$nextTick(_ => {
        this.correctEvents = []
        this.formatEvents()
        this.firstEvent = true
      })
    },
    onEventClick (evt) {
      this.$emit('onEventClick', this.dragLesson)
    },
    eventTop (event) {
      let calStartTime = moment(event.start).set({
        'hours': moment(this.calStartTime).format('HH'),
        'minutes': moment(this.calStartTime).format('mm')
      })
      let eventStartTime = moment(event.start)
      let duration = moment(eventStartTime).diff(calStartTime)
      let eventTop = ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
      return eventTop
    },
    eventHeight (event) {
      let duration = moment(event.end).diff(event.start)
      return ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
    },
    eventBottom (event) {
      let calStartTime = moment(event.start).set({
        'hours': moment(this.calStartTime).format('HH'),
        'minutes': moment(this.calStartTime).format('mm')
      })
      let eventEndTime = moment(event.end)
      let duration = moment(eventEndTime).diff(calStartTime)
      return ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
    },
    formatEvents () {
      let dayEventsPresence = this.dayLessons.filter(event => event.event_type === 'presence')
      this.setWidthAndLeft(dayEventsPresence)
      let backgroundEvent = this.dayLessons.filter(event => event.rendering && event.event_type !== 'presence')
      this.setWidthAndLeft(backgroundEvent)
      let dayEvents = this.dayLessons.filter(event => event.event_type !== 'presence' && !event.rendering)
      this.setWidthAndLeft(dayEvents)
    },
    setWidthAndLeft (dayLessons) {
      let columns = []
      let lastEventEnding = null

      // Map events with their positioning details and retrieve the class name
      let events = dayLessons.map(elem => {
        const top = this.eventTop(elem)
        const height = this.eventHeight(elem)
        const bottom = this.eventBottom(elem)

        return {
          'obj': elem,
          'top': top,
          'height': height,
          'bottom': bottom
        }
      })

      // Sort by top position first, then bottom, and finally class name
      events = events.sort(function (e1, e2) {
        if (e1.top < e2.top) return -1
        if (e1.top > e2.top) return 1
        if (e1.bottom < e2.bottom) return 1
        if (e1.bottom > e2.bottom) return -1
        // Secondary sort by className if both top and bottom are the same
        return e1.obj.v_sort_key.localeCompare(e2.obj.v_sort_key)
      })

      for (let i = 0; i < events.length; i++) {
        let e = events[i]
        if (lastEventEnding !== null && e.top >= lastEventEnding) {
          this.packEvents(columns)
          columns = []
          lastEventEnding = null
        }
        let placed = false
        for (let j = 0; j < columns.length; j++) {
          let col = columns[j]
          if (!this.collidesWith(col[col.length - 1], e)) {
            col.push(e)
            placed = true
            break
          }
        }
        if (!placed) {
          columns.push([e])
        }
        if (lastEventEnding === null || e.bottom > lastEventEnding) {
          lastEventEnding = e.bottom
        }
      }
      if (columns.length > 0) {
        this.packEvents(columns)
      }
    },
    packEvents (columns) {
      let n = columns.length
      for (let i = 0; i < n; i++) {
        let col = columns[i]
        for (let j = 0; j < col.length; j++) {
          let ev = col[j]
          let colSpan = this.expandEvent(ev, i, columns)
          col[j].left = (i / n) * 100
          col[j].width = 100 * colSpan / n
          col[j].cols = n
          // Added to make absence with events next to it width 80
          if (n > 1 && j === 0) {
            let aTop = col[j].top
            let bTop = columns[j + 1][0].top
            // 20px => it is under the event title
            if (bTop - aTop > 20) {
              col[j].width = 90
            }
          }
          this.correctEvents.push(col[j])
          // Scroll cal to first event
          if (this.firstEvent) {
            this.$emit('lessonsUpdate', this.correctEvents[0])
          }
          this.firstEvent = false
        }
      }
    },
    expandEvent (ev, iColumn, columns) {
      let colSpan = 1
      for (let i = iColumn + 1; i < columns.length; i++) {
        let col = columns[i]
        for (let j = 0; j < col.length; j++) {
          let ev1 = col[j]
          if (this.collidesWith(ev, ev1)) {
            return colSpan
          }
        }
        colSpan++
      }
      return colSpan
    },
    // Check if two events collide
    collidesWith (a, b) {
      return a.bottom > b.top && a.top < b.bottom
    },
    goToCalendar (calendarId, evt) {
      window.location.href = '/calendars/' + calendarId
    },
    customTooltip (obj) {
      const parentCalendarName = obj.v_other_calendar && obj.v_other_calendar.name ? obj.v_other_calendar.name : this.i18n['the_calendar']
      return this.i18n['go_to'] + ' ' + parentCalendarName
    }
  }
}
</script>

<style scoped>

.day-cal__event-container,
.day-cal__event-container__events {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  touch-action: auto;
  /* touch-action: auto; https://betterprogramming.pub/perfecting-drag-and-drop-in-pure-vanilla-javascript-a761184b797a */
}

.day-cal__event-container__events {
  z-index: 32;
  margin-right: 8px;
}

.day-cal__event-container__events__draggable {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.day-cal__event {
  --borderRadius: 3px;
  color: white;
  display: block;
  min-height: 12px;
  font-size: .85em;
  line-height: 1.3;
  font-weight: 400;
  position: absolute;
  z-index: 1;
  top: 20px;
  left: 0%;
  right: 0%;
  border-right: 1px solid transparent !important;
  border-top: 1px solid transparent !important;
  border-radius: var(--borderRadius);
  will-change: height, width, left, top;
  contain: layout;
  touch-action: none; /* https://betterprogramming.pub/perfecting-drag-and-drop-in-pure-vanilla-javascript-a761184b797a */
  user-select: none;
}

.day-cal__event:not(.day-cal__event--dragged) {
  transition: opacity 0.2s ease;
}

.day-cal__event:not(.day-cal__event--dragged):not(.fc-bgevent__presence):hover {
  min-height: 25px;
  z-index: 123123;
  min-width: 40%;
}

.day-cal__event:not(.day-cal__event--dragged):not(.day-cal__event--is-other-calendar):hover .day-cal__event__bg {
  opacity: 1;
}

.d-event__resizer {
  position: absolute;
  z-index: 2;
  bottom: 0;
  height: 7px;
  left: 0;
  right: 0;
  cursor: ns-resize;
}

.day-cal__event:not(.day-cal__event--is-locked).day-cal__event--editable:not(.day-cal__event--dragged) .d-event__resizer:after {
  content: "=";
  position: absolute;
  text-align: center;
  font-size: 8px;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
}

.day-cal__event.day-cal__event--dragged {
  z-index: 100 !important;
  opacity: 0.8;
}

.day-cal__event.day-cal__event--dragged:after {
  content: "=";
  position: absolute;
  text-align: center;
  bottom: 0;
  left: 0;
  right: 0;
}

.day-cal__event.day-cal__event--editable:not(.fc-bgevent__presence):not(.day-cal__event--is-locked) {
  cursor: move;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
}

.day-cal__event.day-cal__event--clickable:not(.fc-bgevent__presence):not(.day-cal__event--editable) {
  cursor: pointer;
}

.day-cal__event.day-cal__event--is-locked.day-cal__event--clickable:not(.fc-bgevent__presence) {
  cursor: pointer;
}

.day-cal__event__content {
  color: white;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 1px 3px 1px 8px;
  left: 0;
  top: 0;
  font-size: 10px;
  z-index: 1;
  overflow: hidden;
  border-radius: var(--borderRadius);
  text-shadow: 0 0.5px 0 hsl(0deg 0% 4.85% / 40%);
}

.day-cal__event.day-cal__event--is-small .day-cal__event__content {
  font-size: 8px;
}

.day-cal__event__bg {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0.9;
  border-radius: var(--borderRadius);
  transition: opacity 0.1s;
}

.day-cal__event__content--loading + .day-cal__event__bg,
.day-cal__event__content--loading + div + .day-cal__event__bg {
  z-index: 3;
  pointer-events: none;
  cursor: not-allowed;
}

.day-cal__event__content--loading + .day-cal__event__bg:after,
.day-cal__event__content--loading + div + .day-cal__event__bg:after {
  content: '';
  position: absolute;
  top: calc(50% - 8px);
  left: calc(50% - 8px);
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-left-color: transparent;
  border-radius: 50%;
  animation: spinner 0.7s infinite linear;
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


.day-cal__event__sider {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 4px;
  z-index: 2;
  border-radius: var(--borderRadius);
}

.d-cal__event-meta {
  margin-left: 2px;
}

.fc-bgevent__presence {
  background: rgba(153, 197, 244, 0.3) !important;
  border-radius: 0 !important;
  border: none !important;
  width: auto !important;
  right: -8px !important;
}

.fc-bgevent__presence .day-cal__event__content {
  display: none;
}

.d-cal__event-title {
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
}

.day-cal__event__content__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.day-cal__event__calendar {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d-cal__event-time__start {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.day-cal__event--hide {
  opacity: 0.5 !important;
  /*visibility: hidden !important; */
}

.day-cal__event-container__events__draggable .day-cal__event {
  user-select: none !important;
}

.day-cal__event-container__events--active {
  z-index: 44;
  cursor: move;
}

.day-cal__event-container__events--active--resizing {
  cursor: ns-resize;
}

.day-cal__event--other-school {
  cursor: not-allowed !important;
  border-radius: 0 !important;
}

.day-cal__event--other-school .day-cal__event__bg {
  background-color: #000000 !important;
  opacity: 0.3 !important;
  cursor: not-allowed !important;
  border-radius: 0 !important;
}

.day-cal__event--other-school .day-cal__event__sider {
  background-color: #cccccc !important;
}

@keyframes fadeInEvents {
  0% {
    transform: scale(0.95)
  }
  100% {
    transform: scale(1)
  }
}

.day-cal__event--availability:not(.fc-bgevent__presence) {
  animation: fadeInEvents 0.25s;
  position: absolute;
  z-index: 123123123;
  opacity: .55;
  filter: alpha(opacity=55);
  /* from: https://css-tricks.com/stripes-css/ */
  background: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 10px,
    #ccc 10px,
    #ccc 20px
  ),
  linear-gradient(
    to bottom,
    #f6f7f8,
    #999999
  );
  border-radius: 5px;
}

.d-cal__event-meta__fixed {
  position: absolute;
  top: 0;
  right: 0;
  font-weight: normal;
  border-radius: 0 0 0 4px;
  font-size: 10px;
  line-height: 0;
  padding: 1px;
  color: #a26206;
  background-color: #fefce8;
  display: flex;
  align-items: center;
  gap: 0.25rem
}

.d-cal__event-meta .tw-icon {
  width: 13px;
}

.tw-icon--warning {
  margin-bottom: -1px;
}

.day-cal__event--has-warning .d-cal__event-time {
  margin-right: 14px;
}

.day-cal__event:not(.day-cal__event--is-other-calendar) .day-cal__event__content__header {
  background-color: transparent !important;
}

.d-cal__event__other-calendar {
  position: absolute;
  top: 0;
  z-index: 123123123131;
  left: 0;
  padding: 1px 1.5px;
  line-height: 0;
  border-radius: 0 0 2px 0;
  transition: background-color 0.15s, transform 0.15s;
  background-color: rgba(0, 0, 0, .25);
  transform: translateX(-100%);
}

body:not(.device--is-mobile) .day-cal__event--is-other-calendar:hover .d-cal__event__other-calendar {
  transform: translateX(0);
}

.day-cal__event--is-other-calendar .d-cal__event-title {
  transition: margin-left 0.15s;
}

body:not(.device--is-mobile) .day-cal__event--is-other-calendar:hover .d-cal__event-title {
  margin-left: 15px;
}

.d-cal__event__other-calendar:hover {
  background-color: rgba(255, 255, 255, .75) !important;
}

.d-cal__event__other-calendar svg {
  stroke: #fff !important;
}

.d-cal__event__other-calendar:hover svg {
  stroke: rgba(0, 0, 0, 1) !important;
}

.d-cal__event__other-calendar .tw-icon {
  width: 12px;
}

.day-cal__event--is-other-calendar .day-cal__event__content {
  padding: 1px 3px;
  border-radius: 0;
}

.day-cal__event--is-other-calendar .day-cal__event__bg {
  border-radius: 0;
}

.d-event__side__resizer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 5px;
  z-index: 2;
  cursor: ew-resize;
}

.day-cal__event:not([data-cols="1"]) .d-cal__event-time .d-cal__event-time__start {
  display: none;
}

.day-cal__event:not([data-cols="1"]):not([data-cols="2"]) .day-cal__event__content {
  font-size: 8px;
}

.day-cal__event:not([data-cols="1"]) .day-cal__event__content {
  font-size: 9px;
}

.day-cal__event:not(.day-cal__event--dragged):not(.fc-bgevent__presence):not([data-cols="1"]):hover .d-cal__event-time .d-cal__event-time__start {
  display: block;
}

.day-cal__event-container__events--highlighted .day-cal__event--is-other-calendar,
.day-cal__event-container__events--highlighted .day-cal__event[data-subject-type="absence"],
.day-cal__event-container__events--highlighted .day-cal__event--availability {
  opacity: 0.1 !important;
  pointer-events: none;
}

.day-cal__event--is-canceled .day-cal__event__content {
  color: #71717a;
  text-shadow: none;
}

.day-cal__event--is-canceled .day-cal__event__bg {
  position: relative;
  background-color: #fff !important;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='none' viewBox='0 0 100 100'><path d='M100 0 L0 100 ' stroke='red' stroke-width='2'/><path d='M0 0 L100 100 ' stroke='red' stroke-width='2'/></svg>");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%, auto;
}

.d-cal__event-meta__fixed.d-cal__event-meta__fixed--canceled {
  background-color: #fddddd;
  color: #c20006;
  padding: 2px 4px;
}

.day-cal__event--is-canceled.day-cal__event--is-other-calendar {
  border: #eee;
}


</style>



// WEBPACK FOOTER //
// DCalendarDayDraggable.vue?0b31bbc0